export const updateSkills=(skillsDetails)=>{
    return{type:"UPDATE_SKILLS" , skillsDetails : skillsDetails }
}
